<template>
  <modal ref="modal">
    <span slot="activator">
      <slot name="activator"></slot>
    </span>
    <div slot="header">Send product to ERP</div>
    <div class="header">
      <h2>
        <slot name="header"></slot>
      </h2>
    </div>
    <div class="toolbar">
      <slot name="toolbar"></slot>
    </div>
    <div class="content">
      <div class="infos">
        <div>Order N°{{ order.id_order }}</div>
        <div>Product id N° {{ value.id_product }}</div>
      </div>
      <div class="erp-form">
        <div class>
          <label for="cutwait">To Cut &amp; Wait</label>
          <input
            id="cutwait"
            v-model="sendERP.cutWait"
            class="ui checkbox"
            type="checkbox"
            name="cutWait"
          />
        </div>
        <div class>
          <label for="measurement">New Measurement</label>
          <input
            id="measurement"
            v-model="sendERP.measurement"
            class="ui checkbox"
            type="checkbox"
            name="measurement"
          />
        </div>
        <div class>
          <label for="wascutwait">Was in Cut &amp; Wait</label>
          <input
            id="wascutwait"
            v-model="sendERP.wasCutWait"
            class="ui checkbox"
            type="checkbox"
            name="wasCutWait"
          />
        </div>
        <div>
          <label>Option</label>
          <select v-model="sendERP.option" class="ui selection dropdown">
            <option class="item" value="SHIRT_MAKING_STANDARD">Normal</option>
            <option class="item" value="SHIRT_MAKING_PACK">Package</option>
            <option class="item" value="SHIRT_REMAKE">Remake</option>
            <option class="item" value="FREE_REMAKE">Free remake</option>
            <option class="item" value="COLLAR_MAKING">Collar only</option>
            <option class="item" value="CUFF_MAKING">Cuff only</option>
          </select>
        </div>
        <div class="ui form">
          <label>Comment</label>
          <textarea v-model="sendERP.comment"></textarea>
        </div>
        <div class>
          <button
            v-if="value.sent_to_erp == 0"
            :disabled="loading == true"
            class="ui button green"
            @click="showModal = true"
          >
            Send to ERP
          </button>
          <button
            v-if="value.sent_to_erp == 1"
            :disabled="loading == true"
            class="ui button yellow"
            @click="showModal = true"
          >
            Send to ERP
          </button>
        </div>
      </div>
    </div>
    <popup-modal
      ref="confirmErpModal"
      :index="showModal"
      icon="checkmark"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Are you sure you want to send this product to the ERP ?"
      @delete="sendToERP()"
      @cancel="showModal = null"
    ></popup-modal>
  </modal>
</template>

<style scoped>
.erp-form {
  width: 700px;
  margin: 0 auto;
  border: 1px solid #ccf;
  border-radius: 10px;
}

.erp-form > div {
  margin: 10px;
}

.erp-form label {
  display: inline-block;
  width: 150px;
  vertical-align: top;
}

.erp-form textarea {
  min-width: 300px;
  min-height: 100px;
}
</style>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Erp',
  props: {
    value: {
      type: Object,
      default: null
    },
    order: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      sendERP: {
        comment: '',
        cutWait: 0,
        measurement: false,
        wasCutWait: false,
        id_order: null,
        option: null,
        id_product: null
      },
      showModal: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'getCurrentCustomer'
    })
  },
  watch: {
    value() {
      this.sendERP.comment = this.value.commentaires
      this.sendERP.cutWait = parseInt(this.value.cut_wait, 10)
      this.sendERP.measurement = parseInt(this.value.new_measurement, 10)
      this.sendERP.wasCutWait = parseInt(this.value.was_cut_wait, 10)
      this.sendERP.option = this.value.option
    }
  },
  mounted() {
    this.sendERP.comment = this.value.commentaires
    this.sendERP.cutWait = parseInt(this.value.cut_wait, 10)
    this.sendERP.measurement = parseInt(this.value.new_measurement, 10)
    this.sendERP.wasCutWait = parseInt(this.value.was_cut_wait, 10)
    this.sendERP.option = this.value.option
  },
  methods: {
    sendToERP() {
      this.showModal = null
      this.loading = true
      this.sendERP.id_order = this.order.id_order
      this.sendERP.id_product = this.value.id_product
      //         var data = {
      //           id_order: this.order.id_order,
      //           id_product: this.value.id_product
      //         };
      axios
        .post('/erp/product', this.sendERP)
        .then((response) => {
          // eslint-disable-next-line
          console.log(response)
          this.$awn.success('Product successfully updated.')
          this.loading = false
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ERPModal.vue?5eb961ef